import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { SongOrderInfoWrapper } from '../HelperComponents/StyledComponents';
import { removeSongFromOrder } from '../../actions/OrderActions';
import TuesdayCollectiveDefaultImg from '../../images/tuesday-collective-default.jpg';
import {
  stripUrlQueryParams,
} from '../../helpers';

export class SongOrderComponent extends Component {
  static propTypes = {
    song: PropTypes.any,
    dispatch: PropTypes.func
  };

  removeSongFromOrder = () => {
    this.props.dispatch(removeSongFromOrder(this.props.song));
  }

  render() {
    let album = this.props.song.product_album;
    const albumUrl = stripUrlQueryParams(album.url);
    const albumImage = <img src={albumUrl || TuesdayCollectiveDefaultImg} alt={album.post_title} style={{ borderRadius: '14px' }}/>;

    return (
      <Fragment>
        <div className="columns is-multiline is-mobile">
          <div className="column is-narrow" style={{ paddingRight: '0' }}>
            <figure className="image is-64x64">
              {albumImage}
            </figure>
          </div>
          <SongOrderInfoWrapper className="column is-flex is-half-mobile">
            <section>
              <p>{this.props.song.title ? this.props.song.title.rendered : this.props.song.post_title}</p>
              <small>{this.props.song.genre}</small>
            </section>
            <p>
              <span className="has-text-white" style={{ borderBottom: '1px solid #fff', cursor: 'pointer' }} onClick={this.removeSongFromOrder}>Remove</span>
            </p>
          </SongOrderInfoWrapper>
        </div>
      </Fragment>
    );
  }
}

export const SongOrder = connect()(SongOrderComponent);


// WEBPACK FOOTER //
// ./src/components/SongOrder/SongOrder.js